import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_DOMAIN } from '../../Reusable_Components/Config/apiConfig';
import katibuLogo from '../../../assets/katibu-logo.png';

/* ── Email icon ───────────────────────────────────────────────── */
const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1.5" y="3.5" width="13" height="9" rx="2"
      stroke="#3a4055" strokeWidth="1.4" />
    <path d="M1.5 5.5 L8 9.5 L14.5 5.5"
      stroke="#3a4055" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ── Back arrow icon ──────────────────────────────────────────── */
const BackIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M9 2 L4 7 L9 12"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ── Success check icon ───────────────────────────────────────── */
const CheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="22" stroke="#22c55e" strokeWidth="2" />
    <path d="M14 24 L21 31 L34 17"
      stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ── Main Component ──────────────────────────────────────────── */
const ForgotPasswordPage = () => {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      await axios.post(`${API_DOMAIN}security/audit/password-reset/`, { email });
      setSuccess(true);
    } catch (err) {
      if (err.response?.status === 404) {
        /* Still show success — don't reveal whether the account exists */
        setSuccess(true);
      } else {
        setError('Unable to process your request. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className={`login-top-loader${loading ? ' login-top-loader--active' : ''}`} />

      {/* Logo */}
      <div className="login-logo">
        <img src={katibuLogo} alt="Katibu — Limitless Growth" className="login-logo-img" />
      </div>

      {/* Card */}
      <div className="login-card">

        {success ? (
          /* ── Success state ───────────────────────────────── */
          <div className="fp-success">
            <div className="fp-success-icon"><CheckIcon /></div>
            <h2 className="fp-success-title">Check Your Email</h2>
            <p className="fp-success-body">
              If an account exists for <strong>{email}</strong>, a password
              reset link has been sent. Check your inbox and spam folder.
            </p>
            <Link to="/login" className="fp-back-btn">
              <BackIcon /> Back to Login
            </Link>
          </div>
        ) : (
          /* ── Request form ────────────────────────────────── */
          <>
            <div className="login-card-system-name">
              <span className="login-card-system-name-crm">Password Recovery</span>
              <span className="login-card-system-name-mgmt">Reset Access</span>
            </div>
            <div className="login-card-divider" />
            <h1 className="login-card-title">Forgot Password?</h1>
            <p className="login-card-subtitle">
              Enter the email linked to your account and we'll send you a reset link.
            </p>

            {error && <div className="login-error">{error}</div>}

            <form className="login-fields" onSubmit={handleSubmit}>
              <div className="login-field-group">
                <label className="login-field-label">Email Address</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon"><EmailIcon /></span>
                  <input
                    type="email"
                    className="login-input"
                    placeholder="Enter your account email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    autoFocus
                  />
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? (
                  <>
                    <div className="login-spinner" />
                    Sending Reset Link…
                  </>
                ) : (
                  <>
                    <span className="login-btn-arrow">→</span>
                    Send Reset Link
                  </>
                )}
              </button>
            </form>

            <div className="fp-back-row">
              <Link to="/login" className="fp-back-link">
                <BackIcon /> Back to Login
              </Link>
            </div>

            {/* Footer */}
            <div className="login-card-footer">
              <img src={katibuLogo} alt="Katibu" className="login-footer-logo" />
              <span className="login-footer-text">
                ERP v3.1.2 &nbsp;•&nbsp; Secure Session Lock &nbsp;•&nbsp; Licensed to Main Branch
              </span>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default ForgotPasswordPage;
